import { render } from "./borderBottomColor.vue?vue&type=template&id=616c56e8"
import script from "./borderBottomColor.vue?vue&type=script&lang=js"
export * from "./borderBottomColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__